// extracted by mini-css-extract-plugin
export default {"container":"OfnpYXS7H32aREBnL0fq"};